module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [(!_vm.urlCode) ? _c('div', {
    ref: "backbtn",
    staticClass: "fl iconfont icon-backwards",
    class: {
      'touched': _vm.touchedClass
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goback()
      }
    }
  }, [_c('span', {
    staticClass: "headText",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goback()
      }
    }
  }, [_vm._v("返回")])]) : _vm._e(), _vm._v(" "), (_vm.hasGesture) ? _c('div', {
    staticClass: "fr iconfont icon-gesture"
  }, [_c('span', {
    staticClass: "headText"
  }, [_vm._v("向左滑动")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.pageTitle))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-d4ee4cb8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-d4ee4cb8"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/index/head.vue
// module id = 1082
// module chunks = 1